// removed by extract-text-webpack-plugin
module.exports = {"title":"_1b-iY5mzlb7F8dHtUNX6Mw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/StatisticsSelectedProjectInfo/StatisticsSelectedProjectInfo.scss
// module id = 1332
// module chunks = 1